import * as React from 'react';
import type { BasePortletStore, PoeStateChangedCallback } from 'ehs-react';
import { createPortletStore } from 'ehs-react';
import type { at } from './generated/Beans';
import { MainView } from './MainView';
type FrontendConfigurationBean = at.sense.portlets.saf.virtualvisitpatient.beans.config.FrontendConfigurationBean;

/**
 * The Portlet store.
 *
 * It contains the portlet url, frontend configuration, orchestratable instance to send workflow events, and other state needed by everything, such as maybe a portlet-wide loadmask state.
 * This is automatically filled by the POE.
 *
 * usePortletStore is a hook for use inside react components, which will re-render whenever the state they request changes.
 * PortletStoreApi is for use in callbacks and async functions, not in the view.
 */
export const [usePortletStore, PortletStoreApi] = createPortletStore<
  BasePortletStore<FrontendConfigurationBean>
>(undefined);

/**
 * The main App component.
 *
 * It should render the MainView, possibly a portlet-wide loadmask and any global buttons.
 */
export function App(): JSX.Element {
  return <MainView />;
}

/**
 * Will be called upon state change of workflow.
 * @param event the event name
 */
export const poeStateChanged: PoeStateChangedCallback = async event => {
  console.debug(
    '%cPoeStateChanged triggered with event=' + event,
    'color: green'
  );
};
